// import DataSoap from "@/services/DataSoap";
import { DetailSoap, DetailSpri, Spri } from "@/types";
// import UserLogin from "@/utility/User";
import { storeSoap } from "./soap";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import DataRujukan from "@/services/DataRujukan";
import DataSpri from "@/services/DataSpri";

export interface SpriState {
  spri: Spri[];
  detailspri: DetailSpri;
  soap: DetailSoap;
}

@Module({ store, dynamic: true, namespaced: true, name: "storeSpri" })
class SpriStore extends VuexModule implements SpriState {
  spri: Spri[] = [];
  detailspri = {} as DetailSpri;
  //   detailrujukan = {} as DetailRujukan;
  detailspriid = {} as DetailSpri;
  //   faskes: Faskes[] = [];
  soap = {} as DetailSoap;
  loading = false;

  @Mutation
  SET_SPRI(spri: Spri[]) {
    this.spri = spri;
  }

  @Mutation
  SET_DETAIL_SPRI(detailspri: DetailSpri) {
    this.detailspri = detailspri;
  }

  @Mutation
  SET_DETAIL_SPRI_ID(detailspriid: DetailSpri) {
    this.detailspriid = detailspriid;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action act_spri_on_reg(reg: string | number) {
    this.SET_LOADING(true);

    DataSpri.getDataSpri(reg)
      .then(dt => {
        // console.log('spri',dt['status'])
        const spri = dt["data"];
        const detailspri = dt["data"]?.[0];

        this.SET_SPRI(spri);
        this.SET_DETAIL_SPRI(detailspri);
      })
      .finally(() => {
        this.SET_LOADING(false);
      });
  }

  // action get spri by register, nanti harus ngarah ke sini semua act_spri_on_reg harus dihapus
  @Action getSpriByRegister(reg: string | number) {
    this.SET_LOADING(true);

    DataSpri.getDataSpri(reg)
      .then(dt => {
        const spri = dt["data"];
        const detailspri = dt["data"]?.[0];

        this.SET_SPRI(spri);
        this.SET_DETAIL_SPRI(detailspri);
      })
      .finally(() => {
        this.SET_LOADING(false);
      });
  }

  // @Action act_spri_on_reg_new(reg: string | number) {
  //   const dt = DataSpri.getDataSpri(reg);
  //   dt.then(dt => {
  //     const status = "";
  //     const spri = [];
  //     const detailspri = {} as DetailSpri;
  //     //   detailrujukan.tujuan = {} as Faskes;
  //     detailspri.riwayat_penyakit = storeSoap.detailSoap[0].s;
  //     detailspri.pemeriksaan_fisik = storeSoap.detailSoap[0].o;
  //     detailspri.diagnosis = storeSoap.detailSoap[0].a;
  //     detailspri.terapi = storeSoap.detailSoap[0].p;
  //     // console.log('new')
  //     // this.SET_RUJUKAN(rujukan);
  //     this.SET_DETAIL_SPRI(detailspri);
  //   });
  // }

  // @Action act_spri_on_id(id: number) {
  //   const dt = DataRujukan.getDataRujukanId(id);
  //   dt.then(dt => {
  //     const spri = dt;
  //     const detailspri = dt.data;
  //     const status = dt.status;
  //     this.SET_DETAIL_SPRI_ID(detailspri);
  //   });
  // }
}

export const storeSpri = getModule(SpriStore);
